import * as React from 'react';

export function TargetAudience() {
  return (
    <section className="verdu-audience">
      <style>{`
        .verdu-audience {
          padding: 72px 24px;
          background: #fff;
        }
        .verdu-audience-inner {
          max-width: 800px;
          margin: 0 auto;
        }
        .verdu-audience h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 36px;
          text-align: center;
        }
        .verdu-audience-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 40px;
        }
        .verdu-audience-col h3 {
          font-size: 16px;
          font-weight: 700;
          color: #1EAA25;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin: 0 0 16px;
        }
        .verdu-audience-col ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .verdu-audience-col li {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 0;
          font-size: 16px;
          color: #333;
          border-bottom: 1px solid #f0f0f0;
        }
        .verdu-audience-col li:last-child {
          border-bottom: none;
        }
        .verdu-audience-col li i {
          color: #1EAA25;
          font-size: 14px;
          flex-shrink: 0;
          width: 20px;
          text-align: center;
        }
        @media (max-width: 640px) {
          .verdu-audience-grid {
            grid-template-columns: 1fr;
            gap: 32px;
          }
          .verdu-audience h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="verdu-audience-inner">
        <h2>¿Para quién es este servicio?</h2>
        <div className="verdu-audience-grid">
          <div className="verdu-audience-col">
            <h3>Ideal para</h3>
            <ul>
              <li><i className="fa fa-carrot" /> Verdulerías</li>
              <li><i className="fa fa-apple-whole" /> Fruterías</li>
              <li><i className="fa fa-store" /> Minimercados</li>
              <li><i className="fa fa-basket-shopping" /> Almacenes</li>
              <li><i className="fa fa-leaf" /> Dietéticas</li>
            </ul>
          </div>
          <div className="verdu-audience-col">
            <h3>Que quieren</h3>
            <ul>
              <li><i className="fa fa-check" /> Dejar de ir al Mercado todos los días</li>
              <li><i className="fa fa-check" /> Precios predecibles</li>
              <li><i className="fa fa-check" /> Entrega en el local</li>
              <li><i className="fa fa-check" /> Facturación formal</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
